import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M10 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M14 8v8","key":"svg-2"}]]

const IconSquareNumber4 = createReactComponent('outline', 'square-number-4', 'SquareNumber4', __iconNode);

export default IconSquareNumber4;